import { useNavigate, Link, useLocation } from "react-router-dom";
import { useEffect, useState, useContext, useRef } from "react";
import Toaster from "../../Components/Toaster";
import Rest from '../../Services/Rest';
import TokenService from "../../Services/Token.service";
import { SampleRequestService } from "../../Services/SampleRequest.Service";
import { UserService } from "../../Services/User.service";
import { LabsService } from "../../Services/Labs.service";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import UserProfileDetails from "../../Components/AdministrativeSettings/UserProfileDetails";
import { formatCurrency } from "../../Utils/Common";
import { Helmet } from "react-helmet";
import Loader from "../../Components/Loader";
import { GlobalInfo } from '../../Contexts/GlobalContext';
import ChangePasswordModal from "../../Components/ChangePasswordModal";
import { SampleService } from "../../Services/Sample.service";
import moment from "moment/moment";
import ConfirmationModal from "../../Components/ConfirmationModal";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";
import BiologicalSex from "./BiologicalSex";
import RaceEthnicity from "./RaceEthnicity";
import DonateSample from "./DonateSample";
import HealthQestionnaire from "./HealthQuestionnaire";

function ProfileSettings() {
    const { updateUserDetails } = useContext(GlobalInfo); 
    const [isFormDirty, setIsFormDirty] = useState(false);

    const checkIfExists = (column, value) => {
        if(value!==userData.email){ 
        return Rest.post(`/user/exists`, { column, value })
            .then(response => response.data.exists)
            .catch(error => {
                console.error('Error checking if exists:', error);
                return false;
            });
        }
        return Promise.resolve(false);
    };
    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [userData, setUserData] = useState({});
    const [validationSchema, setValidationSchema] = useState();
    const [userRoles, setUserRoles] = useState(TokenService.getUserRoles());
    const [loading, setLoading] = useState(false);
    const [samples, setSamples] = useState({});
    const [selectedGender, setSelectedGender] = useState("");
    
    const [raceData, setRaceData] = useState([]);  
    const [singleHeritage, setSingleHeritage] = useState([]);
    const [dualHeritage, setDualHeritage] = useState([]);

    const [demographicsData, setDemographicsData] = useState({
        raceDualHeritage: [],
        raceSingleHeritage: '',
    }); 

    const formikRef = useRef();
    // const [selectedAddress, setSelectedAddress] = useState(null);
    const addressListRef = useRef(null);


    const [sampleCosts, setSampleCosts] = useState({});
    const [selectedSampleIds, setSelectedSampleIds] = useState({});

    const [labs, setLabs] = useState([]);
    const [selectedLab, setSelectedLab] = useState(null);

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmChangePassword = async (params) => {

        setLoading(true);
        params.user_id = userData.id;

        try {
            const response = await UserService.changePassword(params);
            if (response.status == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');                
                setLoading(false);
                handleCloseDeactivateModal();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {
            setToastMessage("Failed to change password");
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }     

    };


    const location = useLocation();
    const navigate = useNavigate();
    function scrolltoDonorSection() {
         if (location.hash === "#donate-sample") {
            // Wait for DOM to settle before manipulating elements
            const timeout = setTimeout(() => {
            // Open accordion if not already expanded
            const accordionButton = document.querySelector(
                '[data-rr-ui-event-key="donate-sample"] button'
            );

            if (accordionButton && accordionButton.getAttribute("aria-expanded") === "false") {
                accordionButton.click();
            }

            // Scroll to the donate section
            const donateSection = document.querySelector("#donate-sample-section");
            donateSection?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, ); // Delay to ensure DOM/layout is ready

            return () => clearTimeout(timeout); // Cleanup on unmount
        }
    }
    // useEffect(() => {
    //     if (location.hash === "#donate-sample") {
    //         // Wait for DOM to settle before manipulating elements
    //         const timeout = setTimeout(() => {
    //         // Open accordion if not already expanded
    //         const accordionButton = document.querySelector(
    //             '[data-rr-ui-event-key="donate-sample"] button'
    //         );

    //         if (accordionButton && accordionButton.getAttribute("aria-expanded") === "false") {
    //             accordionButton.click();
    //         }

    //         // Scroll to the donate section
    //         const donateSection = document.querySelector("#donate-sample-section");
    //         donateSection?.scrollIntoView({ behavior: "smooth", block: "start" });
    //         }, 500); // Delay to ensure DOM/layout is ready

    //         return () => clearTimeout(timeout); // Cleanup on unmount
    //     }
    // }, [location]);


    useEffect(() => { 
        if (location.state?.toastMessage) {
            setShowToast(true);
            setToastMessage(location.state.toastMessage);
            setToastVariant(location.state.toastVariant);
            
            setTimeout(() => {
                if (addressListRef.current) {
                    addressListRef.current.scrollIntoView({ behavior: 'smooth' });
                }
            },900);
            // Clear location.state to prevent the toast from triggering on refresh
            navigate(location.pathname, { replace: true }); 

            // Clear toast state after displaying
            return () => {
                setShowToast(false);
                setToastMessage(null);
                setToastVariant(null);
            };
        }
    }, [location.state, showToast, navigate, location.pathname]);
    
    // Validation schema using Yup
    const donorValidations = () => {
        const validationSchema = Yup.object().shape({
            first_name: Yup.string().required('First Name is required'),
            middle_name: Yup.string().required('Middle Name is required'),
            last_name: Yup.string().required('Last Name is required'),
            email: Yup.string()
                .email('Invalid email format')
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
                .required('Email is required'), 
            phone_number: Yup.string()
                .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
                .required('Phone Number is required'),
            date_of_birth : Yup.date().required('Date of Birth is required')
                .test('age-range', 'You must be between 18 and 65 years old', function (value){
                    if(!value) return false;
                    const birthDate = moment(value);
                    const today = moment();
                    const age = today.diff(birthDate, 'years');
                    return age >=18 && age <=65;
                })
            , 
            donor_lab_id: Yup.string().required('Lab is required'),

        });
        setValidationSchema(validationSchema);
    };

    const otherUserValidations = () => {
        const validationSchema = Yup.object().shape({
            first_name: Yup.string().required('First Name is required'),
            middle_name: Yup.string().required('Middle Name is required'),
            last_name: Yup.string().required('Last Name is required'),
            email: Yup.string()
                .email('Invalid email format')
                // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
                .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
                .required('Email is required'),
                // .test('email-unique', 'Email already exists', function (value) {
                //     if (!value) return true;
                //     return checkIfExists('email', value).then((exists) => {
                //         return !exists;
                //     });
    
                // }),

            lab_id: Yup.string().required('Lab is required'),
            phone_number: Yup.string()
                .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
                .required('Phone Number is required'),
            address: Yup.string().required('Address is required'),
            city:Yup.string().required('City name is required'),
            state : Yup.string().required('State name is required'),
            country : Yup.string().required('Country name is required'),
            // gender: Yup.string().required('Gender is required'),
            date_of_birth : Yup.date().required('Date of Birth is required')
                .test('age-range', 'You must be between 18 and 65 years old', function (value){
                    if(!value) return false;
                    const birthDate = moment(value);
                    const today = moment();
                    const age = today.diff(birthDate, 'years');
                    return age >=18 && age <=65;
                })
            ,
        });
        setValidationSchema(validationSchema);
    };

    useEffect(() => { 
        fetchProfile();
    }, []); 

    useEffect(() => { 
        console.log(userData);
        console.log(userRoles);
        if(userData && Object.entries(userData).length > 0 && userData.roles.includes("Donor") ) {       //&& parseInt(userData?.is_donor_status)
            donorValidations();
        } else if(userData && Object.entries(userData).length > 0) {
            otherUserValidations();
        } 
    }, [userData]);

    const handleSampleChange = (setFieldValue, id, checked) => {

        const updatedSampleIds = {
            ...selectedSampleIds,
            [id]: !selectedSampleIds[id],
        };     
        setSelectedSampleIds(updatedSampleIds);      
        setFieldValue("sample_types", updatedSampleIds);        
    };

    const fetchLabs = async () => {
        setLoading(true); 
        try {
            const response = await LabsService.getLabList();
            setLabs(response.labs || []);
            setLoading(false); 
        } catch (error) {
            setLoading(false); 
            console.error("Error fetching labs", error);
        }
    };

    const fetchProfile = async ($status) => {
        setLoading(true); 

        try {
            const userData = await UserService.viewProfile(TokenService.getUserId());
            if(userData.success) {
                let blood_volume = 0;
                const sample_types = userData.profile?.samples ? userData.profile.samples.reduce((acc, { sample_id, volume }) => {
                    if (sample_id === 1) {
                        blood_volume = volume && volume != null ? volume : 0;
                    }
                    acc[sample_id] = true;
                    return acc;
                }, {}) : {};
                userData.profile.sample_types = sample_types;
                userData.profile.blood_volume = blood_volume;
                userData.profile.is_requestor_status = userData.profile.is_requestor_status.toString();
                userData.profile.is_donor_status = userData.profile.is_donor_status.toString();

                // const dob = new Date(2002, 8, 9); // Month is zero-based: 8 = September
                // const formatted = dob.toISOString().split('T')[0]; // "2002-09-09"
                // userData.profile.date_of_birth= formatted; 

                userData.profile.addresses = userData.addresses;
                //uncomment this when My Addresses required
                // userData.profile.selectedAddresses = userData.selectedAddresses || [];
                //race 
                // userData.profile.type_id = userData.race_options[0].type_id || null;
                // if(userData.profile.type_id && userData.profile.type_id == 1){
                    
                //     userData.profile.raceSingleHeritage = userData.race_options[0].race_id;
                // }
                // else{
                //     const raceDualHeritage = userData.race_options.map((race) => race.race_id)
                //     userData.profile.raceDualHeritage = raceDualHeritage;
                // }
                
                //code to populate race options if exists
                if (userData.race_options && userData.race_options.length > 0) {
                    userData.profile.type_id = userData.race_options[0].type_id || null;
                
                    if (userData.profile.type_id === 1) {
                        // Single Heritage
                        userData.profile.raceSingleHeritage = userData.race_options[0].race_id || '';
                        userData.profile.raceDualHeritage = []; // Ensure dual heritage is cleared
                    } else if (userData.profile.type_id === 2) {
                        // Dual Heritage
                        userData.profile.raceDualHeritage = userData.race_options.map((race) => race.race_id);
                        userData.profile.raceSingleHeritage = ''; // Ensure single heritage is cleared
                    }
                } else {
                    // If no race_options exist, ensure defaults
                    userData.profile.type_id = null;
                    userData.profile.raceSingleHeritage = '';
                    userData.profile.raceDualHeritage = [];
                }

                setSelectedSampleIds(sample_types); 
                setUserData(userData.profile || {}); 
                setSelectedGender(userData.profile.gender || ""); 
                

                if(userRoles.includes("Donor")) {
                    setSelectedLab(userData.profile.donor_lab_id);
                } else if(userRoles.includes("Requestor")) {
                    setSelectedLab(userData.profile.lab_id);
                }               
               fetchLabs();
                if(userData.profile.is_requestor_status == "1" || userData.profile.is_donor_status == "1") {
                    // fetchLabs(); // this calls if are you requesing or are you donation  one of them is yes according to previous impletmentation.
                }

                if(userRoles && (userRoles.some(role => role === 'Donor' || role === 'Admin' || role === 'Superadmin'))) {
                    await getRaceOptions();
                }
                
                if(userData.profile.is_donor_status == "1") {
                    await fetchSamples(userData.profile.donor_lab_id);
                }

                if(typeof $status !== 'undefined' && $status === "update") {
                    const updatedProfile = { ...userData.profile }
                    delete updatedProfile.roles;
                    delete updatedProfile.samples;
                    TokenService.updateUserRoles(userData.profile.roles);
                    TokenService.updateUserMenu(userData.menus);
                    TokenService.updateUser(updatedProfile);

                    const combinedUserData = {
                        roles: userData.profile.roles,
                        menus: userData.menus,
                        user: updatedProfile,
                    };
                    updateUserDetails(combinedUserData);
                }
                scrolltoDonorSection();
                setLoading(false); 
            } else {
                setUserData({});
                setToastMessage(userData.message);
                setToastVariant('error');
                setLoading(false); 
            }
        } catch (error) {
            setUserData({});
            setLoading(false); 
            console.error("Error fetching sample types", error);
        }
    }

    const fetchSamples = async (lab_id) => {
        if(!lab_id){
            setSamples({});
            setSampleCosts({});
            return;
        }
        setLoading(true); 

        try {
            const params = {
                lab_id: lab_id
            } 
            const sampleRates = await SampleRequestService.getCompensationAndAppointmentDuationDetails(params);

            const seen = new Set();
            const samplesObj = sampleRates && sampleRates.data ? 
            sampleRates.data.map(({ sample_id, sample_name }) => ({ sample_id, sample_name }))
            .filter(({ sample_id, sample_name }) => {
                const key = `${sample_id}-${sample_name}`;
                if (seen.has(key)) {
                    return false;
                }
                seen.add(key);
                return true;
            }) : {};

            const sampleCosts = sampleRates && sampleRates.data ? sampleRates.data.map(({ sample_id, cost, to_range }) => ({
                sample_id,
                cost,
                to_range,
            })) : {};

            setSamples(samplesObj || {});
            setSampleCosts(sampleCosts || {});
            setLoading(false);            
        } catch (error) {
            setSamples({});
            setLoading(false); 
            console.error("Error fetching sample types", error);
        }
    }

      const getRaceOptions = async () => {
    
        const result = await SampleService.getRaceOptions();
        if (result.success) {
    
          console.log("race options retrived sucessfully");
          setRaceData(result.race_option);
    
          // Extract and set heritage types separately
          const single = result.race_option.find(option => option.type_id === 1);
          const dual = result.race_option.find(option => option.type_id === 2);
    
          console.log("single", single); console.log("dual", dual);
    
    
          // setSingleHeritage(single ? single.race_options.map(r => r.heritage_name) : []);
          // setDualHeritage(dual ? dual.race_options.map(r => r.heritage_name) : []);
          setSingleHeritage(single || []);
          setDualHeritage(dual || []);
        }
        else {
          console.log("failed while getting race options")
        }
      }

    const getSampleCost = (sampleId, values) => {
        
        const bloodVolume = values?.['blood_volume'] !== undefined ? values['blood_volume'] : 0;
        const sample = sampleCosts.find(({ sample_id, to_range }) => {
            if (sample_id === sampleId) {
                if (sampleId === 1 && bloodVolume > to_range) {
                    return false; 
                }
                return true; 
            }
            return false;
        });
        if (sample) {
          return { cost: formatCurrency(sample.cost), to_range: sample.to_range || 'N/A'};
        }
        return { cost: formatCurrency(0), to_range: 0};
    };

    const transformToDonateSamples = (samples, blood_volume) => {
        const donateSamples = {};       
       
        if(samples !== undefined ) {
            Object.keys(samples).forEach(sampleId => {
                const sampleStatus = samples[sampleId];
                if(sampleStatus == true) {
                    donateSamples[sampleId] = {
                        willing_to_donate: 1, 
                        volume: sampleId == 1 ? blood_volume : null
                    };
                }
            });
        }        
    
        return donateSamples;
    };

    const handleSubmit = async (values, { resetForm , setSubmitting, setFieldError}) => {
        const emailExists = await checkIfExists('email', values.email);
        if (emailExists) {
            setFieldError('email', 'Email already exists');
            setSubmitting(false);
            return;
        }
        setLoading(true); 
        const requestorData = {
            user_id: userData.id,
            first_name: values.first_name,
            middle_name: values.middle_name,
            last_name: values.last_name,
            phone_number: values.phone_number,
            address: values.address,
            city: values.city,
            state : values.state,
            country : values.country,
            // removed from here because handled in seperate block and api call
            // gender: values.gender,
            sequence: 1,
            email: values.email,
            request_sample: typeof values.is_requestor_status !== 'undefined' ? parseInt(values.is_requestor_status) : 0, 
            // donate_sample: typeof values.is_donor_status !== 'undefined' ? parseInt(values.is_donor_status) : 0,
            // donate_samples: {},
            //removed from here because handled in seperate block and api call
            // type_id : values.type_id,
            // race_options: values.type_id == 1 
            // ? (values.raceSingleHeritage ? [values.raceSingleHeritage] : [])
            // : values.raceDualHeritage ?? [],

            date_of_birth : values.date_of_birth,
            //uncomment this when My Addresses required
            // selectedAddresses : values.selectedAddresses
        
        };

        if(userRoles && (userRoles.some(role => role === 'Donor' || role === 'Admin' || role === 'Superadmin'))) {
            requestorData.donor_lab_id = selectedLab;
            requestorData.lab_id = selectedLab;
        }

        if(userRoles && (userRoles.some(role => role === 'Requestor' || role === 'Admin' || role === 'Superadmin'))) {
            requestorData.lab_id = selectedLab;
        }

        let params = {
            ...requestorData
        };

        if(userRoles && (userRoles.some(role => role === 'Donor' || role === 'Admin' || role === 'Superadmin'))) {
            // const donateSamples = transformToDonateSamples(values?.['sample_types'], values?.['blood_volume']);           
            // params.donate_samples = donateSamples;
        }           
        

        try {           
            const data = await UserService.updateUser(params);           
            if (!data.success) {
                let message = '';
                if (typeof data.message === 'object' && data.message !== null) {
                    message = Object.values(data.message).flat().join(', '); 
                } else if (Array.isArray(data.message)) {
                    message = data.message.join(', ');
                } else {
                    message = data.message || 'An unknown error occurred.';
                }
                setToastMessage(message);
                setToastVariant('error');
                setLoading(false);
            } else {
                // fetchProfile("update");                
                setToastMessage(data.message);
                setToastVariant('success');
                setLoading(false);
            }
        } catch (error) {
            setToastMessage('Failed to update profile.');
            setToastVariant('error');
            setLoading(false);
        } finally {            
            setShowToast(true);
        }
    };

    const handleSampleOption = (setFieldValue, id, value) => {
        if(value == "1") {
            fetchLabs();
        }
        if(id == 'is_donor_status' && value == "1") {
            fetchSamples(selectedLab);
        }

        setFieldValue(id, value);   

        if(value=="1" && id=="is_donor_status"){//c
            donorValidations();
        } 
        else if (value=="0" && id=="is_donor_status"){
            otherUserValidations();
        }

        // if(value=="1" && id=="is_requestor_status" && selectedLab == ""){//c
        //     otherUserValidations();
        // }
    };
    useEffect(()=>{ //c
        
        // if(formikRef.current?.values.is_requestor_status == "1" && formikRef.current?.values.is_donor_status=="0" && selectedLab == '') { 
        //     otherUserValidations();
        // }
    },[selectedLab]); 
    useEffect(()=>{
        console.log("demographicsData",demographicsData);
    },[demographicsData]); 

    const labRef = useRef(null);

    const handleDonateYes = () => {
        if (!formikRef.current?.values.lab_id) {
            // set error
            formikRef.current.setFieldTouched("lab_id", true);
            formikRef.current.setFieldError("lab_id", "Lab is required");

            // scroll to lab field
            labRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }
    };

    const [labChangedAt, setLabChangedAt] = useState(null);
    

    return (
        <>
            <Loader loading={loading} />
            
            <Helmet>
                <title>DonorX | Profile Settings</title>
            </Helmet>

            <div className="el-middle-wrapper">
                <h2 className="el-title">Profile Settings</h2>     
                {userData.roles && (
                <>
                    {/* Calculate rolesString */}
                    {(() => {
                        // const rolesString = userData?.roles?.length === 0 
                        //     ? "Super Admin" 
                        //     : userData?.roles?.join(", ");
                        const rolesString = userData?.roles?.length === 0
                            ? "Super Admin"
                            : [
                                // ...(userData.is_superadmin ? ["Super Admin"] : []),
                                ...userData?.roles
                            ].join(", ");
                        return (
                            <UserProfileDetails 
                                type="profile-settings" 
                                roles={rolesString} 
                                userType={userData.roles?.length === 0 
                                    ? "admin" 
                                    : userData.is_superadmin ? "admin" : userData.roles[0]?.toLowerCase()} 
                                userData={userData}
                                handleShowChangePasswordModal={handleShowDeactivateModal}
                            />
                        );
                    })()}
                </>
            )}          
                
                <div className="">    
                    <>
                        <div>
                        {/* className="el-bg-table el-super-admin mt-5" */}
                            <Formik
                                innerRef={formikRef}
                                initialValues={userData}
                                validationSchema={validationSchema}
                                validateOnBlur={true}
                                validateOnChange={true}
                                onSubmit={handleSubmit}
                                enableReinitialize={true} // Enable reinitialization when initialValues change
                            >
                                {({ values, setFieldValue, errors, touched, setFieldTouched, dirty}) => (
                                    <Form>
                                        <div  className="el-bg-table el-super-admin mt-5">
                                            <div className="row mt-3 mt-md-0 col-xl-12">
                                                {/* 'username', 'email', 'password', 'confirm_password', */}
                                                {['first_name', 'middle_name', 'last_name','email', 'phone_number','address','city', 'state' ,'country'].map((field) => {
                                                    // if (values.is_donor_status === "1" && ['address', 'city', 'state', 'country'].includes(field)) {
                                                    if ( userRoles.includes("Donor")  && ['address', 'city', 'state', 'country'].includes(field)) {
                                                        return null; // Don't render these fields
                                                    }
                                                    return (
                                                    <div className="col-md-4" key={field}>
                                                        <label htmlFor={field} className="form-label">
                                                            {field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <Field
                                                            type={field.includes('password') ? 'password' : field === 'phone_number' ? 'number' : 'text'}
                                                            maxLength={field === 'phone_number' ? 10 : undefined}
                                                            onInput={(e) => {
                                                                if (field === 'phone_number' && e.target.value.length > 10) {
                                                                    e.target.value = e.target.value.slice(0, 10);
                                                                }
                                                                else if(field == 'email'){ 
                                                                    e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                                }
                                                                else {
                                                                    if(!field=='address' && !field=='city' && !field=='state' &&!field=='country'){
                                                                        // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                                        e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                                    }
                                                                }
                                                            }}
                                                            name={field}
                                                            value={values[field] ? values[field] : ''}   
                                                            className={`form-control ${field === 'phone_number' ? 'no-arrows' : ''}`}
                                                            placeholder={`Enter ${field
                                                                .replace(/_/g, ' ')
                                                                .trim()
                                                                .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                        />
                                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                                    </div>
                                                    )
                                                })}
                                                <div className="col-md-4">
                                                    <label htmlFor="date_of_birth" className="form-label">
                                                        Date of Birth <span className="text-red">*</span>
                                                    </label>
                                                    <Field
                                                        type="date"
                                                        name="date_of_birth"
                                                        className="form-control"
                                                        value={values.date_of_birth ? values.date_of_birth : ''}
                                                        onChange={(e) => {setFieldValue("date_of_birth", e.target.value);setFieldTouched("date_of_birth", true);}}
                                                    />
                                                    {/* {errors['date_of_birth'] && (
                                                        <ErrorMessage name="date_of_birth" component="div" className="text-danger" />
                                                    )}
                                                    <ErrorMessage name="date_of_birth" component="div" className="text-danger" /> */}
                                                    {/* &&  touched['date_of_birth']  */}
                                                    {errors['date_of_birth'] && (<>
                                                        <div name="date_of_birth" className="text-danger" >{(errors['date_of_birth'])}</div></>
                                                    )}
                                                </div>
                                                {/* {(values.is_requestor_status === "1" || values.is_donor_status === "1") && ( */}
                                                    <div className="col-md-4" ref={labRef}>
                                                        <label htmlFor="lab_id" className="form-label">Lab<span className="text-red">*</span></label>
                                                        <select
                                                            as="select"
                                                            name="lab_id"
                                                            className="form-control"
                                                            value={typeof selectedLab !== 'undefined' && selectedLab != null ? selectedLab : ''}
                                                            onChange={(e) => {
                                                                fetchSamples(e.target.value);
                                                                setSelectedLab(e.target.value);
                                                                setFieldValue("lab_id", e.target.value); 
                                                                setFieldValue("donor_lab_id", e.target.value); 
                                                                setLabChangedAt(Date.now());
                                                            }}
                                                        >
                                                            <option value="">Please select lab</option>
                                                            {labs?.map((lab) => (
                                                                <option key={lab.id} value={lab.id}>{lab.name}</option>
                                                            ))}
                                                        </select>
                                                        {/*  &&  touched['lab_id'] */}
                                                        {errors['lab_id'] && (<>
                                                            <div name="lab_id" className="text-danger" >{(errors['lab_id'])}</div></>
                                                        )}
                                                        {errors['donor_lab_id'] && (<>
                                                            <div name="donor_lab_id" className="text-danger" >{(errors['donor_lab_id'])}</div></>
                                                        )}
                                                        {/* {touched['lab_id'] && errors['lab_id'] && ( */}
                                                            {/* <ErrorMessage name="lab_id" component="div" className="text-danger" /> */}
                                                        {/* )} */}
                                                    </div>
                                            </div>
                                            <div className="row mt-3 mt-md-0 col-xl-12">
                                                {(userRoles &&
                                                    userRoles.includes('Requestor') &&             // must have Requestor
                                                    !userRoles.includes('Admin') &&                // must NOT have Admin
                                                    !userRoles.includes('Superadmin')  ) && ( //|| role === 'Admin' || role === 'Superadmin'                     
                                                    <div className="col-md-4">
                                                        <label className="form-label">Will you request samples? <span className="text-red">*</span></label>
                                                        <div className="d-flex justify-content-between  mt-3  ms-3 w-40">
                                                            {["1", "0"].map((is_requestor_status) => (
                                                                <div className="form-check " key={is_requestor_status}>
                                                                    <Field type="radio" name="is_requestor_status" value={is_requestor_status} className="form-check-input" onChange={() => handleSampleOption(setFieldValue, "is_requestor_status", is_requestor_status)}/>
                                                                    <label className="form-check-label">&nbsp; {is_requestor_status == 1 ? 'Yes' : 'No'}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <ErrorMessage name="gender" component="div" className="text-danger" />
                                                    </div>                                       
                                                )} 
                                            </div>
                                        <div className="d-flex align-items-center mt-3">
                                            <button type="submit" className="el-main-button me-3"> <span>Save Changes</span> </button>
                                        </div>  
                                        </div>
   
                                    {/* {JSON.stringify(dirty)} */}
                                    {/* <div className="debug-section mt-3 p-2 bg-light border rounded">
                                    <h6 className="fw-bold">Form Debug</h6>
                                    <div>
                                        <strong>Errors:</strong>
                                        <pre className="text-danger">
                                        {JSON.stringify(errors, null, 2)}
                                        </pre>
                                    </div>
                                    <div>
                                        <strong>Values:</strong>
                                        <pre className="text-primary">
                                        {JSON.stringify(values, null, 2)}
                                        </pre>
                                    </div>
                                    </div> */}
                                    </Form>
                                )}
                            </Formik>


                            <div className="profile-setting-accord">
                                <div className="el-card-content el-custom-accordion">
                                        {/*  className="d-sm-flex align-items-md-center" */}
                                        <div className="el-property-details-card-content">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <Accordion alwaysOpen defaultActiveKey={["0","1","donate-sample","3","4","5","6", "7"]} flush>
                                                     {userRoles && userRoles.includes("Donor") && (
                                                        <BiologicalSex userData={userData} selectedGender={selectedGender} setSelectedGender={setSelectedGender} setToastMessage={setToastMessage} setToastVariant={setToastVariant} setShowToast={setShowToast} setLoading={setLoading}/>
                                                    )}
                                                        <div>
                                                        {userRoles &&
                                                            userRoles.some(
                                                            (role) => role === "Donor" //|| role === "Admin" || role === "Superadmin"
                                                            ) && (
                                                            <>
                                                                <RaceEthnicity
                                                                demographicsData={demographicsData}
                                                                setDemographicsData={setDemographicsData}
                                                                raceData={raceData}
                                                                singleHeritage={singleHeritage}
                                                                dualHeritage={dualHeritage}
                                                                userData={userData}
                                                                setToastMessage={setToastMessage} setToastVariant={setToastVariant} setShowToast={setShowToast} setLoading={setLoading}
                                                                />

                                                                {/* Old DonateSample usage */}
                                                                {/* <DonateSample
                                                                samples={samples}
                                                                selectedSampleIds={selectedSampleIds}
                                                                handleSampleChange={handleSampleChange}
                                                                getSampleCost={getSampleCost}
                                                                setFieldValue={setFieldValue}
                                                                values={values}
                                                                touched={touched}
                                                                errors={errors}
                                                                /> */}

                                                                <DonateSample
                                                                userData={userData}
                                                                samples={samples}
                                                                getSampleCost={getSampleCost}
                                                                fetchSamples={fetchSamples}
                                                                selectedLab={selectedLab}
                                                                setToastMessage={setToastMessage} setToastVariant={setToastVariant} setShowToast={setShowToast} setLoading={setLoading}
                                                                handleDonateYes = {handleDonateYes}
                                                                labChangedAt={labChangedAt} 
                                                                fetchProfile ={fetchProfile} 
                                                                />
                                                                <HealthQestionnaire userData={userData} selectedGender={selectedGender} 
                                                                setToastMessage={setToastMessage} setToastVariant={setToastVariant} setShowToast={setShowToast}
                                                                setLoading={setLoading}/>
                                                            </>
                                                            )}
                                                        </div>

                                                </Accordion> 
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>            
            
            <ChangePasswordModal 
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmChangePassword}
            />
            {/* <ConfirmationModal 
                show={showDeleteAddressModal}
                onHide={handleCloseDeleteAddressModal}
                onConfirm={confirmDeleteAddress}
                body={`Are you sure want to delete this address?`}
            /> */}

            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default ProfileSettings;